// Which sibling host is this SPA serving? (#754) The SAME bundle backs both
// `app.developerz.ai` (the customer dashboard) and `admin.developerz.ai` (the
// platform-admin radar) — Traefik routes both hosts to one dashboard service.
// The host decides which CHROME renders: the admin host lands on `/admin` and
// shows only the radar nav; the app host shows the product nav. This is
// COSMETIC only — the real gate is server-side (`admin:read:*` scopes behind
// the `platformAdmin` grant) + `<AdminGate/>`; flipping hosts grants nothing.

/** The production admin host. */
const ADMIN_HOST = 'admin.developerz.ai';

/**
 * True when the SPA is being served as the admin radar. In a dev/preview build
 * a `?host=admin` override lets e2e + local work exercise the admin chrome off
 * `localhost`; it's dead-code-eliminated from prod (`import.meta.env.DEV`), so
 * prod decides purely on the hostname.
 */
export function isAdminHost(): boolean {
  if (typeof window === 'undefined') return false;
  if (import.meta.env.DEV && new URLSearchParams(window.location.search).get('host') === 'admin') {
    return true;
  }
  return window.location.hostname === ADMIN_HOST;
}
